import { Component, OnInit, NgZone } from '@angular/core';
import { Router, ActivatedRoute, Route } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '../../../_services/api.service';
import { AnpiService } from '../../../_services/anpi-code.service';
import { first } from 'rxjs/operators';
import { NgxUiLoaderService, Loader, SPINNER, POSITION, PB_DIRECTION } from 'ngx-ui-loader';
import { MatSnackBar } from '@angular/material/snack-bar';
declare var $: any;
import AOS from 'aos';
import 'aos/dist/aos.css';
import { log } from 'console';

@Component({
  selector: 'app-add-bank',
  templateUrl: './add-bank.component.html',
  styleUrls: ['./add-bank.component.scss']
})
export class AddBankComponent implements OnInit {

  response: any;
  isSubmitted = false;
  public bankDetailsForm: FormGroup;
  bankdata: any;
  bank = false;
  currentUserDetails: any;
  currentLang: string;
  responseupload: any;
  bank_slip: any;
  employeeData: any;

  constructor(private router: Router,
    private formBuilder: FormBuilder,
    private api: ApiService,
    private route: ActivatedRoute,
    private anpiService: AnpiService,
    private ngzone: NgZone,
    private ngxUiLoaderService: NgxUiLoaderService,
    private snackBar: MatSnackBar) { }

  ngOnInit() {
    this.anpiService.changeEvent.subscribe(() => {
      console.log("35")
      this.bankDetailsForm.get('banks').setValue('1');
    });
    this.bankDetailsForm = this.formBuilder.group({
      banks: ['1', [Validators.required]],
      // account_number: ['', [Validators.required, Validators.pattern("^[0-9]*$")]],
      // account_name: [''],
      // bank_name: ['', [Validators.required, Validators.pattern("^(?! )[a-zA-ZÀ-ÖØ-öø-ÿ,'` -]+$")]],
      // bank_number: [''],
      // bank_counter: [''],
      account_number: [''],
      account_name: [''],
      bank_name: [''],
      bank_number: [''],
      bank_counter: [''],
      bank_slip: ['', [Validators.required]]
    });

    if (!this.api.getValidationStatus()) {
      this.api.getFormValidation(this.bankDetailsForm);
      // this.api.getFormValidation(this.mobileMoneyForm);
    }
    AOS.init({
      disable: function () {
        var maxWidth = 600;
        return window.innerWidth < maxWidth;
      }
    });
    $("#bankAccountModal").on('shown.bs.modal', (e) => {
      console.log("sdsadsadsadsadasd")
      setTimeout(() => {
        AOS.refresh();
        this.getBanks();
        console.log("sdsadsadsad232222sadasd")
      }, 100);
      if (this.bankdata) {
        console.log($('#bank1'))
        setTimeout(() => {
          this.ngzone.run(() => {
            console.log("fdsfdsfsdfd")
            $('#bank1').prop('checked', true);
            // this.bank = true;
            // this.g['bank_number'].setValidators([Validators.required]);
            // this.g['bank_number'].updateValueAndValidity();
            // this.g['bank_slip'].updateValueAndValidity();
            // this.bankDetailsForm.controls['bank_name'].setValue(this.bankdata[0].bank_name);
          });
        }, 1000)
      }
    });
    // this.getCurrentUserFirstName()
    this.currentLang = localStorage.getItem('language') || "fr";
  }

  onSubmitBankForm() {
    this.bankDetailsForm.updateValueAndValidity();
    this.isSubmitted = true;
    console.log("77", this.bankDetailsForm)
    if (this.bankDetailsForm.invalid) {
      return;
    } else {
      var data = {
        account_no: this.g.account_number.value,
        account_name: this.g.account_name.value,
        bank_name: this.g.bank_name.value,
        bank_counter: this.g.bank_counter.value,
        bank_no: this.g.bank_number.value,
        bank_id: this.g.banks.value,
        bank_slip: this.g.bank_slip.value
      }
      console.log("164", data)
      this.ngxUiLoaderService.start();
      this.api.bankDetails(data).pipe(first())
        .subscribe(data => {
          console.log(data)
          this.ngxUiLoaderService.stop();
          this.response = data;
          if (this.response.status == 200) {
            this.getAccountData();
            this.bankDetailsForm.reset();
            this.isSubmitted = false;
            $('#bankAccountModal').modal('hide');
            // localStorage.setItem('bank', "1");
            this.anpiService.emitEvent();
            this.anpiService.emitAccountEvent();
            this.snackBar.open(data.message, "OK", {
              duration: 5000,
            });
            this.router.navigate(['/dashboard']);

          } else {
            this.isSubmitted = false;
            this.snackBar.open(data.message, "OK", {
              duration: 5000,
            });
          }
        },
          error => {
            this.isSubmitted = false;
            this.ngxUiLoaderService.stop();
          });
    }
  }

  upload(event: any, id): void {
    console.log("2250", event)
    console.log("2251", event.target.files[0])

    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      console.log('uploaded image: ', file)
      const filename = file.name;
      var ext = filename.split('.').pop();
      if (file.size > 5242880) {

        if (this.currentLang == 'fr') {
          alert('La taille du fichier doit être inférieure à 5MB')
        } else {
          alert('File Size should be less than 5MB')
        }
        return;
      }
      if (ext != 'jpg' && ext != 'JPG' && ext != 'png' && ext != 'PNG' && ext != 'JPEG' && ext != 'jpeg' && ext != 'pdf' && ext != 'PDF' && ext != 'doc' && ext != "Doc" && ext != 'docx' && ext != "DOCX" && ext != 'bmp' && ext != 'BMP' && ext != 'webp' && ext != 'heic' && ext != 'heif' && ext != 'tiff' && ext != 'TIFF') {
        if (this.currentLang == 'fr') {
          alert('Type de fichier non autorisé. Les types de fichier autorisés sont  .jpg .png .jpeg .pdf .doc .docx .bmp .webp .heic .heif .tiff')
        } else {
          alert('File type not allowed. Allowed file types are .jpg .png .jpeg .pdf .doc .docx .bmp .webp .heic .heif .tiff')
        }
        return;
      }

      this.ngxUiLoaderService.start();
      const target = event.target.dataset.target;
      console.log(target)
      const formData = new FormData();
      formData.append('image', file);
      formData.append('target', target);
      formData['encrypt_mode'] = false;
      console.log("file is :", file)
      console.log("target is :", target)
      // formData['encrypt_mode'] = false;
      // formData.append('uuid', this.businessData.business_code);
      this.api.bankUpload(formData).pipe(first())
        .subscribe(data => {
          this.ngxUiLoaderService.stop();
          if (id == 'bulkUpload') {
            $('#bulkUpload').modal('hide');
            // this.employeeList = false;

          }
          this.responseupload = data;
          if (this.responseupload.status == 200) {
            if (target == 'bank_slip') {
              this.bankDetailsForm.get('bank_slip').setValue(this.responseupload.results.file);
              this.bank_slip = this.responseupload.results.imageUrl;
              console.log("2034");
              this.snackBar.open(this.responseupload.message, "OK", {
                duration: 5000,
              });
            }
          }
        },
          error => {

          });
    }


  }

  // setEmployeebankValues(){
  //   this.bankDetailsForm.controls['bank_slip'].setValue(this.employeeData.slip_Image);
  //   this.bank_slip = this.employeeData.slip_image;


  //   const photoProperties = [
  //     { elementId: 'bank_slip_upload', apiValue: this.employeeData.birth_Image },
  //   ];

  //   for (const property of photoProperties) {
  //     const element = document.getElementById(property.elementId);

  //     if (property.apiValue) {
  //       element.textContent = this.currentLang === 'fr' ?
  //         `Cliquez pour voir le fichier` :
  //         `Click to view File`;
  //     }
  //   }


  // }


  // onSubmitMobileMoneyForm() {
  //   this.isSubmitted = true;
  //   if (this.mobileMoneyForm.invalid) {
  //     console.log("196", this.mobileMoneyForm)
  //     return;
  //   }

  //   var data = {
  //     ac_number: this.h.mobile_money_account_number.value,
  //     ac_name: this.h.mobile_money_account_name.value,
  //     bank_name: this.h.facility_name.value,
  //     bank_number: null
  //   }
  //   this.ngxUiLoaderService.start();
  //   this.api.bankDetails(data).pipe(first())
  //     .subscribe(data => {
  //         this.ngxUiLoaderService.stop();
  //         this.response = data;
  //         if (this.response.status == 200) {
  //           this.mobileMoneyForm.reset();
  //           this.isSubmitted = false;
  //           $('#bankAccountModal').modal('hide');
  //           localStorage.setItem('bank', "1");
  //           this.anpiService.emitEvent();
  //           this.snackBar.open(data.message, "OK", {
  //             duration: 5000,
  //           });
  //           this.router.navigate(['/dashboard']);
  //         } else {
  //           this.isSubmitted = false;
  //           this.snackBar.open(data.message, "OK", {
  //             duration: 5000,
  //           });
  //         }
  //       },
  //       error => {
  //         this.isSubmitted = false;
  //         this.ngxUiLoaderService.stop();
  //       });
  // }

  closeModal() {
    this.isSubmitted = false;
    this.bankDetailsForm.reset();
    this.bank_slip = null;
    $('#bankAccountModal').modal('hide');
  }
  get g() {
    return this.bankDetailsForm.controls;
  }

  getBanks() {
    console.log("260")
    this.ngxUiLoaderService.start();
    this.api.getBankList().pipe(first())
      .subscribe(data => {
        this.ngxUiLoaderService.stop();
        console.log("263", data)
        this.response = data.Results;
        if (data.status == 200) {
          this.bankdata = data.Results;
          console.log("raghavoooo.......1", this.bankdata)
          setTimeout(() => {
            this.ngzone.run(() => {
              console.log("fdsfdsfsdfd")
              console.log("244", this.bankdata)
              $('#bank1').prop('checked', true);
              // this.bank = true
              // this.g['bank_number'].setValidators([Validators.required]);
              // this.g['bank_number'].updateValueAndValidity();
              // this.g['bank_slip'].updateValueAndValidity();
              this.bankDetailsForm.controls['bank_name'].setValue(this.bankdata[0].bank_name);
              this.bankDetailsForm.get('banks').setValue('1');
            });
          }, 2000)
        } else {
          // this.snackBar.open(data.message, "OK", {
          //   duration: 5000,
          // });
        }

      },
        error => {
          this.ngxUiLoaderService.stop();
        });
  }

  handleChange(e, value, banks, type) {
    console.log(value, e, type, "999")
    this.bank_slip = null;
    // this.bankDetailsForm.controls['account_number'].reset();
    // this.bankDetailsForm.controls['bank_number'].reset();
    // this.bankDetailsForm.controls['bank_counter'].reset();
    this.bankDetailsForm.controls['banks'].setValue(banks);
    this.bankDetailsForm.controls['bank_name'].setValue(value);
    this.isSubmitted = false;
    // Bank-type-based form field logic removed: show bank slip only for every bank
    // if (type == 1) {
    //   this.bank = true
    //   this.g['account_number'].setValidators([
    //     Validators.required,
    //     Validators.pattern("^[0-9]{11}$")
    //   ]);
    //   this.g['account_number'].updateValueAndValidity();
    //   this.g['bank_number'].setValidators([Validators.required, Validators.pattern("^[0-9]*$")]);
    //   this.g['bank_number'].updateValueAndValidity();
    //   this.g['bank_slip'].updateValueAndValidity();
    // } else {
    //   this.bank = false
    //   this.g['account_number'].setValidators([
    //     Validators.required,
    //     Validators.pattern("^(77|76|74|66|65|62|60|61)[0-9]{6}$")
    //   ]);
    //   this.g['account_number'].updateValueAndValidity();
    //   this.g['bank_number'].clearValidators();
    //   this.g['bank_number'].setValue('');
    //   this.g['bank_number'].updateValueAndValidity();
    //   this.g['bank_slip'].clearValidators();
    //   this.g['bank_slip'].setValue('');
    //   this.g['bank_slip'].updateValueAndValidity();
    // }
  }


  // getCurrentUserFirstName() {
  //   const currentUser = localStorage.getItem('currentUserDetails');
  //     const currentUserObj = JSON.parse(currentUser);



  //   // setBankAccountName(){
  //     const accountName = `${currentUserObj.first_name} ${currentUserObj.last_name}`;
  //     this.bankDetailsForm.controls['account_name'].setValue(accountName);
  //   // }
  // }

  setBankAccountName() {
    const currentUser = localStorage.getItem('currentUserDetails');
    const currentUserObj = JSON.parse(currentUser);
    const accountName = `${currentUserObj.first_name} ${currentUserObj.last_name}`;
    this.bankDetailsForm.controls['account_name'].setValue(currentUserObj.company_name);
    this.bankDetailsForm.controls['account_name'].updateValueAndValidity();
  }

  getAccountData() {
    console.log("442 get employer details")
    this.ngxUiLoaderService.start();
    this.api.getAccountDetails().pipe(first())
      .subscribe(res => {
        this.ngxUiLoaderService.stop();

        if (res.status == 200) {
          if (res.results.current_user == 1) {
            const data = JSON.stringify(res.results);
            localStorage.setItem('currentUserDetails', data);
          } else if (res.results.current_user == 2) {
            const data = JSON.stringify(res.results.employee);
            localStorage.setItem('currentUserDetails', data);

          }

        }
      },
        error => {
          console.log("errorrrrrrrrr")
          this.ngxUiLoaderService.stop();
        });
    console.log("no result")
  }


}
